import { getQueryParamValue } from 'src/lib/browser';
import * as ls from 'src/lib/localData';
import { ROUTE_PARAMS } from 'src/routes';

// TODO: we can add 'anycopy_widget' and use it for "ExternalAnycopyWidget" view
export const APPLICATION_MODE = {
  default: 'default',
  infinityExtension: 'infinity_extension',
};

export const clampApplicationMode = (value, defaultValue = APPLICATION_MODE.default) => {
  const possibleValues = Object.values(APPLICATION_MODE);
  if (possibleValues.includes(value)) {
    return value;
  }
  return defaultValue;
};

export const getApplicationMode = () => {
  const queryMode = getQueryParamValue(ROUTE_PARAMS.applicationMode);
  const sessionMode = ls.sessionApplicationMode.read();
  return clampApplicationMode(queryMode || sessionMode);
};

export const getApplicationHost = () => {
  const queryHost = getQueryParamValue(ROUTE_PARAMS.host);
  const sessionHost = ls.sessionApplicationHost.read();
  return queryHost || sessionHost || null;
};
